export function jsonToString(json) {
  return JSON.stringify(json);
}

export function stringToJson(string) {
  return JSON.parse(string);
}


// WEBPACK FOOTER //
// ./src/components/other-web/lib/jsonFormatter.js